export const COMPANY_INFORMATION_HEADING = 'GENERAL INFORMATION';
export const DIRECTORS = 'CURRENT DIRECTORS';
export const FORMER_DIRECTORS = 'FORMER DIRECTORS';
export const FINANCIAL_INFO_TABS_LIST = {
  OVERVIEW: 'OVERVIEW',
  PROFIT_LOSS: 'PROFIT & LOSS',
  BALANCE_SHEET: 'BALANCE SHEET',
  RATIOS: 'RATIOS',
  OTHER_FINANCIALS: 'OTHER FINANCIALS',
};

export const DIRECTOR_COLUMNS = {
  name: 'Name',
  match: 'Match',
  dateOfBirth: 'Date of Birth',
  position: 'Position',
  dateAppointed: 'Date Appointed',
  nationality: 'Nationality',
  address: 'Address',
};

export const PROVIDER_SOURCES = {
  CREDITSAFE: 'C',
  DNB: 'D',
  KYCKR: 'K',
  KYCKR_LITE: 'KL',
};

export const SOURCE_PROVIDER: any = {
  C: 'CREDITSAFE',
  D: 'DNB',
  K: 'KYCKR',
  KL: 'KYCKR_LITE',
};

export const FINANCIAL_INFO_ROWS = {
  consolidated: 'CONSOLIDATED',
  currency: 'Currency',
  period: 'Period',
  actualEstimate: 'Actual / Estimate',
  audited: 'Audited',
  turnoverSales: 'Turnover / Sales',
  profitLossBeforeTax: 'Profit / (Loss) Before Taxes',
  grossIncome: 'Gross Income',
  netIncome: 'Net Income',
  shareholderFunds: 'Shareholder Funds',
  totalAssets: 'Total Assets',
  totalFixedAssets: 'Total Fixed Assets',
  totalCurrentAssets: 'Total Current Assets',
  cashAndLiquidAssets: 'Cash and Liquid Assets',
  totalLiabilities: 'Total Liabilities',
  totalLongTermLiabilities: 'Total Long Term Liabilities',
  totalCurrentLiabilities: 'Total Current Liabilities',
  totalLiabilitiesAndEquities: 'Total Liabilities and Equities',
  assets: 'ASSETS',
  miscFixedAssets: 'Misc Fixed Assets',
  miscIntangibleAssets: 'Misc Intangible Assets',
  totalIntangibleAssets: 'Total Intangible Assets',
  currentAssets: 'CURRENT ASSETS',
  stock: 'Stock',
  tradeDebtors: 'Trade Debtors',
  miscDebtors: 'Misc Debtors',
  cash: 'Cash',
  miscCurrentAssets: 'Misc Current Assets',
  totalCurrent: 'TOTAL CURRENT',
  liabilities: 'LIABILITIES',
  capital: 'Capital',
  sharePremium: 'Share Premium',
  retainedProfits: 'Retained Profits',
  profitOfYear: 'Profit of Year',
  miscReserves: 'Misc Reserves',
  netWorth: 'Net Worth',
  miscProvisions: 'Misc Provisions',
  mortgagesLoans: 'Mortgages/Loans',
  miscDefLiabilities: 'Misc Def Liabilities',
  currentLiabilities: 'CURRENT LIABILITIES',
  tradeCreditors: 'Trade Creditors',
  accruals: 'Accruals',
  bankOverdraft: 'Bank Overdraft',
  totalLiabilitiesNetworth: 'TOTAL LIABILITIES & NETWORTH',
  netSales: 'Net Sales',
  costOfGoodsSold: 'Cost of Goods Sold',
  sellingAdminExpenses: 'Selling/Admin Expenses',
  depreciationAmortisation: 'Depreciation/Amortisation',
  miscOperatingCharges: 'Misc Operating Charges',
  miscOperatingIncome: 'Misc Operating Income',
  netOperatingIncome: 'Net Operating Income',
  interestReceivable: 'Interest Receivable',
  groupRelatedIncome: 'Group Related Income',
  miscFinancialIncome: 'Misc Financial Income',
  totalFinancialIncome: 'Total Financial Income',
  interestPayable: 'Interest Payable',
  miscFinancialExpenses: 'Misc Financial Expenses',
  totalFinancialExpenses: 'Total Financial Expenses',
  profitBeforeTax: 'Profit Before Tax',
  incomeTax: 'Income Tax',
  profitAfterTax: 'Profit After Tax',
  netProfit: 'Net Profit',
};

export const FINANCIAL_INFO_DNB_NUMBER_FIELDS = [
  'overview.salesRevenue',
  'overview.profitBeforeTaxes',
  'overview.grossProfit',
  'overview.netIncome',
  'overview.netWorth',
  'overview.totalAssets',
  'overview.fixedAssets',
  'overview.totalCurrentAssets',
  'overview.cashAndLiquidAssets',
  'overview.totalLiabilities',
  'overview.totalLongTermLiabilities',
  'overview.totalCurrentLiabilities',
  'overview.totalLiabilitiesEquity',
];

export const FINANCIAL_INFO_DEFAULT_NUMBER_FIELDS = [
  'profitAndLoss.operatingProfit',
  'profitAndLoss.revenue',
  'profitAndLoss.wagesAndSalaries',
  'profitAndLoss.pensionCosts',
  'profitAndLoss.depreciation',
  'profitAndLoss.amortisation',
  'profitAndLoss.financialExpenses',
  'profitAndLoss.profitBeforeTax',
  'profitAndLoss.tax',
  'profitAndLoss.profitAfterTax',
  'profitAndLoss.dividends',
  'profitAndLoss.minorityInterests',
  'profitAndLoss.otherAppropriations',
  'profitAndLoss.retainedProfit',
  'balanceSheet.totalTangibleAssets',
  'balanceSheet.totalIntangibleAssets',
  'balanceSheet.totalOtherFixedAssets',
  'balanceSheet.totalFixedAssets',
  'balanceSheet.totalInventories',
  'balanceSheet.tradeReceivables',
  'balanceSheet.miscellaneousReceivables',
  'balanceSheet.totalReceivables',
  'balanceSheet.cash',
  'balanceSheet.otherCurrentAssets',
  'balanceSheet.totalCurrentAssets',
  'balanceSheet.totalAssets',
  'balanceSheet.tradePayables',
  'balanceSheet.bankLiabilities',
  'balanceSheet.otherLoansOrFinance',
  'balanceSheet.miscellaneousLiabilities',
  'balanceSheet.totalCurrentLiabilities',
  'balanceSheet.bankLiabilitiesDueAfter1Year',
  'balanceSheet.otherLoansOrFinanceDueAfter1Year',
  'balanceSheet.miscellaneousLiabilitiesDueAfter1Year',
  'balanceSheet.totalLongTermLiabilities',
  'balanceSheet.totalLiabilities',
  'balanceSheet.calledUpShareCapital',
  'balanceSheet.revenueReserves',
  'balanceSheet.otherReserves',
  'balanceSheet.totalShareholdersEquity',
  'otherFinancials.workingCapital',
  'otherFinancials.netWorth',
];

export const CREDIT_SUMMARY_NUMBER_FIELDS = [
  'creditLimitRecommendation.maximumRecommendedLimit.value',
  'currentCreditRating.creditLimit.value',
  'previousCreditRating.creditLimit.value',
];

export const DEFAULT_EMPTY_VALUE = '-'; //not available default values
export const DEFAULT_UNDEFINED_EMPTY_VALUE = '---'; // will be provided by client later
export const DEFAULT_PREV_FINANCIAL_LIMIT = 5;
export const INITIAL_BADGE_VALUE = '...';
export const DOCUMENT_SUBMIT_LOADING_VALUE = '...';

export const ITALY_COUNTRY_CODE = 'IT';
export const ITALY_TYPE_DNB_CODE = 2022;
